import { useEffect, useRef, useState } from 'react'

const SCROLL_RANGE = 240

const SOLID_FROM = 0.5

export function useHeaderScroll() {
    const headerRef = useRef(null)
    const [isSolid, setIsSolid] = useState(false)

    useEffect(() => {
        if (typeof window === 'undefined') {
            return
        }

        let frame = null

        const update = () => {
            frame = null

            const progress = Math.min(1, Math.max(0, window.pageYOffset / SCROLL_RANGE))

            if (headerRef.current) {
                headerRef.current.style.setProperty('--header-scroll-alpha', String(progress))
            }
            setIsSolid(progress >= SOLID_FROM)
        }

        const onScroll = () => {
            if (frame !== null) {
                return
            }

            frame = window.requestAnimationFrame(update)
        }

        update()

        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)

        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('resize', onScroll)

            if (frame !== null) {
                window.cancelAnimationFrame(frame)
            }
        }
    }, [])

    return { headerRef, isSolid }
}
